import { render } from "./FromQuestionEvaluation.vue?vue&type=template&id=01e7954a&scoped=true"
import script from "./FromQuestionEvaluation.vue?vue&type=script&lang=js"
export * from "./FromQuestionEvaluation.vue?vue&type=script&lang=js"

import "./FromQuestionEvaluation.vue?vue&type=style&index=0&id=01e7954a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e7954a"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QBtn,QTooltip,QRadio,QCheckbox});
